








































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

import * as c_interface from '@/interface/components/manageGroups';

const namespace: string = 'manageGroup';

@Component
export default class ModalManufacturer extends Vue {
  @Prop({ type: Boolean, default: false }) dialogVisible!: boolean;
  @Prop({ type: String, default: 'defaultId' }) manufacturerId!: string;

  @Action('setManufacturer', { namespace }) c_setManufacturer!: any;

  public propsDialogVisible: boolean = this.dialogVisible;
  public ruleForm: c_interface.CreateManufacturerPayload = {
    name: '',
    url: '',
    contactName: '',
    contactPhone: '',
    contactEmail: '',
    info: '',
  };
  public rules: any = {
    name: [{ required: true, message: '입력해주세요.', trigger: ['blur', 'change'] }],
  };

  @Emit('emitModalClose')
  modalClose(): boolean {
    this.propsDialogVisible = false;
    return this.propsDialogVisible;
  }

  addSubmit() {
    const groupId: string = this.$route.params.groupId;
    (this.$refs['ruleForm'] as HTMLFormElement).validate(async (valid: boolean) => {
      if (valid) {
        try {
          await this.c_setManufacturer({
            groupId,
            payload: this.ruleForm,
          });
          this.propsDialogVisible = false;
          this.$emit('emitAddSubmit', {
            isShow: this.propsDialogVisible,
          });
        } catch (e) {
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      } else {
        this.$message.error('유효하지 않은 형식의 데이터가 있습니다.');
        return false;
      }
    });
  }
}
